if (!customElements.get('studio-rail')) customElements.define('studio-rail', class extends HTMLElement {
 connectedCallback(){if(this.bound)return;this.bound=true;this.addEventListener('click',e=>{const b=e.target.closest('[data-direction]');if(!b)return;const rail=this.querySelector('.studio-rail');rail.scrollBy({left:Number(b.dataset.direction)*rail.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});}
});
if (!customElements.get('studio-offer')) customElements.define('studio-offer', class extends HTMLElement {
 connectedCallback(){if(this.bound)return;this.bound=true;this.dialog=this.querySelector('dialog');this.key='studio-offer-seen';this.addEventListener('click',e=>{if(e.target.closest('[data-offer-open]'))this.open();if(e.target.closest('[data-offer-close]'))this.close();if(e.target.closest('[data-offer-reveal]')){this.querySelector('[data-offer-reveal]').hidden=true;this.querySelector('[data-offer-result]').hidden=false;}});this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.close();}});this.dialog.addEventListener('close',()=>{try{sessionStorage.setItem(this.key,'1')}catch{}});let seen=false;try{seen=sessionStorage.getItem(this.key)==='1'}catch{}if(!seen&&!window.Shopify?.designMode)this.timer=setTimeout(()=>this.open(),Number(this.dataset.delay)*1000);}
 disconnectedCallback(){clearTimeout(this.timer);if(this.dialog?.open)this.dialog.close();}
 open(){if(!this.dialog.open)this.dialog.showModal();}
 close(){this.dialog.close();}
});

if (!customElements.get('studio-testimonials')) customElements.define('studio-testimonials', class extends HTMLElement {
 connectedCallback(){
  if(this.bound)return;
  this.bound=true;
  this.rail=this.querySelector('.studio-rail');
  if(!this.rail)return;
  this.originalCards=[...this.rail.querySelectorAll('.studio-rail__card')];
  this.mobileQuery=matchMedia('(max-width: 749px)');
  this.abort=new AbortController();
  const options={signal:this.abort.signal};
  this.cards=this.originalCards;
  this.index=0;
  this.mobile=false;
  this.frame=0;
  this.snapReset=0;
  this.slideTimeout=0;
  this.reduceMotion=matchMedia('(prefers-reduced-motion: reduce)');

  this.centerCard=(card,instant=false)=>{
   if(!card)return;
   const r=card.getBoundingClientRect(), c=this.rail.getBoundingClientRect();
   const left=this.rail.scrollLeft+r.left+r.width/2-c.left-c.width/2;
   if(instant){
    // Disable snapping and smooth-scroll for the invisible wrap-around jump.
    this.rail.style.scrollSnapType='none';
    this.rail.style.scrollBehavior='auto';
    this.rail.scrollLeft=left;
    cancelAnimationFrame(this.snapReset);
    this.snapReset=requestAnimationFrame(()=>{
     this.rail.style.removeProperty('scroll-snap-type');
     this.rail.style.removeProperty('scroll-behavior');
    });
   }else{
    this.rail.scrollTo({left,behavior:this.reduceMotion.matches?'instant':'smooth'});
   }
  };
  this.update=()=>{
   if(!this.mobile||!this.cards.length)return;
   const c=this.rail.getBoundingClientRect(),middle=c.left+c.width/2;
   let closest=0,dist=Infinity;
   this.cards.forEach((card,i)=>{
    const r=card.getBoundingClientRect(),d=Math.abs(r.left+r.width/2-middle);
    if(d<dist){closest=i;dist=d;}
   });
   this.index=closest;
   this.cards.forEach((card,i)=>card.classList.toggle('is-current',i===closest));
  };
  this.wrap=()=>{
   if(!this.mobile||this.originalCards.length<2)return;
   this.update();
   const count=this.originalCards.length;
   if(this.index<count||this.index>=2*count){
    const target=this.cards[this.index<count?this.index+count:this.index-count];
    this.centerCard(target,true);
    this.index=this.index<count?this.index+count:this.index-count;
    this.cards.forEach((card,i)=>card.classList.toggle('is-current',i===this.index));
   }
  };
  this.go=delta=>{
   if(!this.mobile||this.originalCards.length<2)return;
   this.update();
   const count=this.originalCards.length;
   let next=this.index+delta;
   if(next<0)next+=count;
   if(next>=this.cards.length)next-=count;
   this.centerCard(this.cards[next],false);
  };
  this.setMode=()=>{
   const mobile=this.mobileQuery.matches && this.originalCards.length>1;
   if(mobile===this.mobile && this.initialized)return;
   this.initialized=true;
   this.mobile=mobile;
   this.rail.querySelectorAll('[data-izuro-clone]').forEach(card=>card.remove());
   this.cards=this.originalCards;
   if(!mobile){
    this.originalCards.forEach(card=>card.classList.remove('is-current'));
    this.rail.scrollLeft=0;
    this.rail.style.removeProperty('scroll-behavior');
    this.rail.style.removeProperty('scroll-snap-type');
    return;
   }
   // One full duplicate sequence on either side, so even the last card has a neighbor.
   const clone=card=>{
    const copy=card.cloneNode(true);
    copy.setAttribute('data-izuro-clone','');
    copy.setAttribute('aria-hidden','true');
    copy.removeAttribute('data-shopify-editor-block');
    copy.removeAttribute('id');
    copy.querySelectorAll('[id],[data-shopify-editor-block]').forEach(el=>{
     el.removeAttribute('id');el.removeAttribute('data-shopify-editor-block');
    });
    return copy;
   };
   const before=this.originalCards.map(clone);
   const after=this.originalCards.map(clone);
   this.rail.prepend(...before);
   this.rail.append(...after);
   this.cards=[...this.rail.querySelectorAll('.studio-rail__card')];
   this.index=this.originalCards.length+Math.floor(this.originalCards.length/2);
   requestAnimationFrame(()=>{
    if(!this.isConnected||!this.mobile)return;
    this.centerCard(this.cards[this.index],true);
    this.cards.forEach((card,i)=>card.classList.toggle('is-current',i===this.index));
   });
  };
  this.addEventListener('click',e=>{
   const button=e.target.closest('[data-step]');
   if(button)this.go(Number(button.dataset.step));
  },options);
  this.rail.addEventListener('keydown',e=>{
   if(!this.mobile||e.target!==this.rail)return;
   if(e.key==='ArrowRight'||e.key==='ArrowLeft'){
    e.preventDefault();this.go(e.key==='ArrowRight'?1:-1);
   }
  },options);
  this.rail.addEventListener('scroll',()=>{
   if(!this.mobile)return;
   cancelAnimationFrame(this.frame);
   this.frame=requestAnimationFrame(this.update);
   clearTimeout(this.slideTimeout);
   this.slideTimeout=setTimeout(this.wrap,190);
  },{...options,passive:true});
  this.rail.addEventListener('scrollend',this.wrap,options);
  this.mobileQuery.addEventListener('change',this.setMode,options);
  this.addEventListener('shopify:block:select',e=>{
   const i=this.originalCards.indexOf(e.target);
   if(i>=0&&this.mobile)this.centerCard(this.cards[this.originalCards.length+i],true);
  },options);
  this.resize=new ResizeObserver(()=>{
   if(this.mobile)this.centerCard(this.cards[this.index],true);
  });
  this.resize.observe(this.rail);
  this.setMode();
 }
 disconnectedCallback(){
  this.abort?.abort();this.resize?.disconnect();
  clearTimeout(this.slideTimeout);
  cancelAnimationFrame(this.frame);cancelAnimationFrame(this.snapReset);
  this.bound=false;
 }
});
// Content stays visible without JavaScript, on failed images, and with reduced motion.
(()=>{
 if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
 const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('studio-reveal-visible');observer.unobserve(entry.target);}}),{threshold:.08}):null;
 function enhance(scope){
  scope.querySelectorAll('.studio-story,.studio-testimonials,.studio-review').forEach(el=>observer?.observe(el));
  scope.querySelectorAll('main img[loading="lazy"]').forEach(img=>{if(img.closest('.product-card-wrapper'))return;if(img.complete||img.dataset.studioLoading)return;img.dataset.studioLoading='true';const finish=()=>{img.classList.remove('studio-image-pending');img.classList.add('studio-image-ready');};img.addEventListener('load',finish,{once:true});img.addEventListener('error',finish,{once:true});if(img.complete)finish();});
 }
 enhance(document);document.addEventListener('shopify:section:load',e=>enhance(e.target));
})();

// Keep showcase audio from overlapping when another video is started.
document.addEventListener('play',event=>{
 if(!(event.target instanceof HTMLVideoElement)||!event.target.closest('.studio-product-videos'))return;
 document.querySelectorAll('.studio-product-videos video').forEach(video=>{if(video!==event.target)video.pause();});
},true);
